import Glide from '@glidejs/glide';

export default function(dom, opts) {
	let options = {
		type: 'carousel',
		perView: 1,
		gap: 0,
		keyboard: false,
		swipeThreshold: 80,
		dragThreshold: 120,
		perTouch: 0,
		touchRatio: 0.5,
		touchAngle: 45,
		rewind: true,
		...opts
	};

	const teasers = Array.from(dom.children).map(teaser => {
		return teaser.cloneNode(true);
	});

	if (!teasers.length) {
		return;
	}

	dom.classList.add(`${dom.className.split(' ')[0]}--carousel`);

	const contentSlider = document.createElement('div');
	const glideRoot = document.createElement('div');
	const glideTrack = document.createElement('div');
	const glideSlides = document.createElement('div');
	const glideBullets = document.createElement('div');
	contentSlider.classList.add('content-slider');
	contentSlider.classList.add('insicht');
	contentSlider.classList.add('insicht--fade-in');
	glideRoot.classList.add('glide');
	glideTrack.classList.add('glide__track');
	glideSlides.classList.add('glide__slides');
	glideBullets.classList.add('glide__bullets');

	glideTrack.dataset.glideEl = 'track';
	glideBullets.dataset.glideEl = 'controls[nav]';

	teasers.forEach((teaser, i) => {
		const glideBullet = document.createElement('button');
		glideBullet.classList.add('glide__bullet');
		glideBullet.dataset.glideDir = `=${i}`;
		glideBullets.appendChild(glideBullet);

		const glideSlide = document.createElement('div');
		glideSlide.classList.add('glide__slide');
		teaser.classList.remove('insicht');

		glideSlide.appendChild(teaser);
		glideSlides.appendChild(glideSlide);
	});

	glideTrack.appendChild(glideSlides);
	glideRoot.appendChild(glideTrack);
	glideRoot.appendChild(glideBullets);
	contentSlider.appendChild(glideRoot);

	dom.appendChild(contentSlider);

	const glide = new Glide(glideRoot, options).mount();
}
